module.exports = __webpack_public_path__ + "e3ae5689a7ffcf5841dad362b335b4a9.png";